import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-bl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-bl.component.scss?ngResource";
import { Component } from "@angular/core";
export let ViewApplicationDetailsBlComponent = class ViewApplicationDetailsBlComponent {
};
ViewApplicationDetailsBlComponent = __decorate([
    Component({
        selector: "app-view-application-details-bl",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsBlComponent);
